import React from 'react';

interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function PhoneInput({ value, onChange, className = '' }: PhoneInputProps) {
  const formatPhoneNumber = (phone: string): string => {
    const numbers = phone.replace(/\D/g, '');
    
    if (numbers.length <= 2) {
      return numbers;
    }
    if (numbers.length <= 7) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    }
    if (numbers.length <= 11) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7)}`;
    }
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value.replace(/\D/g, '');
    if (input.length <= 11) {
      onChange(input);
    }
  };

  return (
    <input
      type="tel"
      value={formatPhoneNumber(value)}
      onChange={handleChange}
      placeholder="(11) 98765-4321"
      className={className}
      maxLength={15}
      required
    />
  );
}